import getTranslate from './getTranslate.js';
import setTranslate from './setTranslate.js';
import minTranslate from './minTranslate.js';
import maxTranslate from './maxTranslate.js';
import translateTo from './translateTo.js';

export defa mx-1  ult {
  getTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo,
};
